define((require) => {
    "use strict";

    const ImprovedModel             = require("shared/zbone/ImprovedModel");
    const RestApi                   = require("shared/services/RestApi");
    const SyncManager                = require("shared/services/sync/SyncManager");


    /**
     *
     * @class SendEmail
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            companyId: 0,
            toAddresses: "",
            htmlBody: "",
            fromPrettyName: "Zmags",
            subjectLine: undefined
        },

        url() {
            const companyId = this.get("companyId");
            const fromPrettyName = this.get("fromPrettyName");
            const toAddresses = this.get("toAddresses");
            const subjectLine = this.get("subjectLine") ? this.get("subjectLine").trim() : "Zmags - Test shoppable Email";

            const constructedUrl = new URL(`${RestApi.PROXY_URL}/${RestApi.Collections.EXPERIENCE_EMAIL_SEND}`);
            constructedUrl.search = new URLSearchParams([
                ["companyId", companyId],
                ["fromPrettyName", fromPrettyName],
                ["toAddresses", toAddresses],
                ["subjectLine", subjectLine]
            ]).toString();
            return constructedUrl.href;
        },

        /**
         * Normally we do not need override Backbone save method, but here is something specific:
         * 1) all model attrs except tableHTML should be passed by query params
         * 2) tableHTML should be passed as text/html directly to the request body
         *
         * @returns {Promise}
         */
        save() {
            return SyncManager.sync({
                method: "post",
                promise: true,
                fn: {
                    url: this.url(),
                    type: "POST",
                    contentType: "text/html",
                    data: this.get("htmlBody")
                },
                resultHandler(response) {
                    return response;
                },
                errorHandler(err) {
                    return err;
                }
            }).promise();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/SendEmail.js